<template>
	<div v-if="passedMaterial">
	<product-identifiers :passed-material="passedMaterial" :product-categories="productCategories"/>
	<flag-section :passed-product="passedMaterial.product" />
	<measurements-section :passed-product="passedMaterial.product"/>
	<meta-data-actions  :passed-material="passedMaterial" :passed-user="currentUser"/>
	</div>
</template>

<script>
import ProductIdentifiers from "./ProductIdentifiers.vue";
import FlagSection from "./FlagSection.vue";
import MeasurementsSection from "./MeasurementsSection.vue";
import MetaDataActions from "./MetaDataActions.vue";

export default {
	name: "MetaDataPanel",
	components: {MetaDataActions, MeasurementsSection, FlagSection, ProductIdentifiers},
	props: {
		passedMaterial: {
			type: Object
			},
		productCategories: {
			type: Array,
			default: () => []
		},
		passedCurrentUser: {
			type: Object
		},
	},
	data() {
		return {
			material: null,
			currentUser: null,
		}
	},
	watch: {
		passedMaterial: {
			handler(newVal) {
				if (!newVal) {
					console.warn("passedMaterial not ready yet");
					return;
				}
				console.log("passedMaterial updated:", newVal);
				this.material = newVal;
			}
		},
		passedCurrentUser: {
			handler(newVal) {
				if (!newVal) {
					console.warn("passedCurrentUser not ready yet");
					return;
				}
				console.log("passedCurrentUser updated:", newVal);
				this.currentUser = newVal;
			}
		},
	},
}
</script>

<style scoped>

</style>